import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useUiStore } from '@shared/stores/uiStore';

interface RouteContainerProps {
  children: ReactNode;
}

const IGNORED_PREFIXES = ['/login', '/forgot-password', '/reset-password', '/403', '/404'];

/** Her route geçişinde fade-in animation + recent push. */
export function RouteContainer({ children }: RouteContainerProps) {
  const location = useLocation();
  const pushRecent = useUiStore((s) => s.pushRecent);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/' || IGNORED_PREFIXES.some((p) => path.startsWith(p))) return;
    pushRecent(path);
  }, [location.pathname, pushRecent]);

  return (
    <div key={location.pathname} className="ds-route-fade">
      {children}
    </div>
  );
}
